import * as React from "react";
import { cls_box, cls_box_horizontal, cls_box_vertical } from "./hbox_vbox.css";
import { join } from "../helpers";
var HBox = function (props) {
    var cls = join(cls_box, cls_box_horizontal, props.className);
    return React.createElement("div", { className: cls, onBlur: props.onBlur, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, props.children);
};
var VBox = function (props) {
    var cls = join(cls_box, cls_box_vertical, props.className);
    return React.createElement("div", { className: cls, onBlur: props.onBlur, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, props.children);
};
export { HBox, VBox, };
